export const BRAND_TXT = "Archiduque Consulting · Pedro Domenech · Consultor de Farmacias · 609467788";
